import { render, staticRenderFns } from "./TravelApply.vue?vue&type=template&id=2fbd91b0&scoped=true&"
import script from "./TravelApply.vue?vue&type=script&lang=js&"
export * from "./TravelApply.vue?vue&type=script&lang=js&"
import style0 from "./TravelApply.vue?vue&type=style&index=0&id=2fbd91b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd91b0",
  null
  
)

export default component.exports